import React, { useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { CommonToastProps } from "../../../../Types/BonusUiType";

const CommonToast: React.FC<CommonToastProps> = ({ icon, smallClass, strongText, smallText, bodyText }) => {
  const [open, setOpen] = useState(true);
  return (
    <Toast isOpen={open}>
      <div className="toast-header">
        {icon}
        <strong className="me-auto">{strongText}</strong>
        <small className={smallClass}>{smallText}</small>
        <Btn close className="p-0" onClick={() => setOpen(false)}></Btn>
      </div>
      <ToastBody className="toast-dark">{bodyText}</ToastBody>
    </Toast>
  );
};
export default CommonToast;
